module.exports = __webpack_public_path__ + "img/company.7bd5584b.jpg";